module.exports = __webpack_public_path__ + "img/hamburger-closed.415a921c.svg";